"use client";

import { useEffect } from "react";

/**
 * P2-09 · Fires the `plp.view` page-view event once per category view (P9 sink).
 * Renders nothing; keyed by the RSC on category id so a client-side param
 * change doesn't re-fire it, but a category change does.
 */
export function PlpViewTracker({
  categoryId,
  resultCount,
}: {
  categoryId: string;
  resultCount: number;
}) {
  useEffect(() => {}, [categoryId, resultCount]);
  return null;
}
